import React, { FC } from 'react';

import DataExplorer from '../../components/DataExplorer';

type Props = {};

const DataExplorerScene: FC<Props> = ({}) => <DataExplorer />;

export default DataExplorerScene;
